// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectAccountOperationInfoMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_ACCOUNT_OPERATION_REQUEST_INFO_MESSAGE);
    }
}
